import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import HeatmapLayer from "react-google-maps/lib/components/visualization/HeatmapLayer";
import { Wkt } from 'wicket/wicket';
import MapSkin from '$constants/map-skin.json';

const wkt = new Wkt();

const convertLocation = (location, fn = false) => {
  const loc = wkt.read(location);

  if (fn) {
    return {
      lng: () => loc.components[0].x,
      lat: () => loc.components[0].y
    }
  } else {
    return {
      lng: loc.components[0].x,
      lat: loc.components[0].y
    }
  }

}

const Map = withScriptjs(withGoogleMap(props => 
  <GoogleMap
    ref={map => {
      props.self.map = map;
      props.self.fitBounds();
    }}
    defaultZoom={15}
    defaultCenter={{ lat: 41.015137, lng: 28.979530 }}
    defaultOptions={{ styles: MapSkin }}
  >
    {
      props.heatmap ? 
        <HeatmapLayer data={props.self.heatMapPoints} options={{ radius: 24, opacity: .7 }}/>
      :
        props.points.map((marker, index) => {
          //const ref = `marker_${index}`;
          return (
            <Marker
              key={index}
              icon={require(`$shared/images/markers/heat.png`)}
              position={convertLocation(marker.location)}
              onClick={props.self.handleMarkerClick.bind(props.self, marker)}
            >
            </Marker>
          )
        })
    }
  </GoogleMap>
));

export default class ActivityMap extends Component {
  static defaultProps = {
    points: []
  };

  handleMarkerClick(marker) {
    window.open(`/project/${this.props.projectId}/submissions/${marker.id}`, '_blank');
  }

  fitBounds() {
    if (!this.map || !this.props.points.length) return;

    var bounds = new google.maps.LatLngBounds();
    this.props.points.forEach(point => {
      bounds.extend(convertLocation(point.location));
    });
    this.map.fitBounds(bounds);
  }

  get heatMapPoints() {
    const { points } = this.props;
    let realPoints = [];

    points.map(marker => {
      const location = convertLocation(marker.location);
      if (typeof location !== "undefined") {
        realPoints.push(new google.maps.LatLng(location['lat'], location['lng']));
      }
    });
    return realPoints;
  }

  render() {
    const { points, height, heatmap } = this.props;

    return (
      <Map
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env[0].GOOGLE_KEY}&v=3.exp&libraries=drawing,visualization`}
        loadingElement={
          <div style={{ height: height || `500px` }} />
        }
        containerElement={
          <div style={{ height: height || `500px` }} />
        }
        mapElement={
          <div style={{ height: height || `500px` }} />
        }
        points={points}
        self={this}
        heatmap={heatmap}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/project/activity-map/activity-map.js